import dayjs from "dayjs";
import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";
import { ProfileInfoCard, StatusBadge, ViewButton } from "@components";

import { RequisitionState } from "@reducers/types/inventory/requisition-state";
import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";
import { useUser } from "@hooks/useUser";
import { STATUS } from "@constants/status.hrm";
import { PERMISSIONS } from "@constants/permissions";

export const RequisitionListTableColumn = (
  t: TFunction<"translation", undefined>,
) => {
  const { user } = useUser();
  const { realm_roles: roles } = user || {};
  return [
    {
      id: 1,
      key: "employee",
      className: "text-nowrap",
      name: t("INVENTORY_REQUISITION.REQUISITION_LIST.HR.TABLE.COLUMN.NAME"),
      render: (employee: EmployeeCommonInfoType, row: RequisitionState) => {
        return <ProfileInfoCard employee={employee} />;
      },
    },
    {
      id: 2,
      key: "employee",
      className: "text-nowrap",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_LIST.HR.TABLE.COLUMN.EMPLOYEE_ID",
      ),
      render: (employee: EmployeeCommonInfoType) => {
        return <Text color="subtitle1">{employee.employeeCode}</Text>;
      },
    },
    {
      id: 3,
      key: "room",
      className: "text-nowrap",
      name: t("INVENTORY_REQUISITION.REQUISITION_LIST.HR.TABLE.COLUMN.ROOM"),
      render: (room: string) => <Text color="subtitle1">{room}</Text>,
    },
    {
      id: 4,
      key: "reqNo",
      className: "text-nowrap",
      name: t("INVENTORY_REQUISITION.REQUISITION_LIST.HR.TABLE.COLUMN.REQ_NO"),
      render: (reqNo: string) => <Text color="subtitle1">{reqNo}</Text>,
    },
    {
      id: 5,
      key: "reqDate",
      className: "text-nowrap",
      name: t(
        "INVENTORY_REQUISITION.REQUISITION_LIST.HR.TABLE.COLUMN.REQ_DATE",
      ),
      render: (reqDate: string) => (
        <Text color="subtitle1" className="text-nowrap">
          {reqDate ? dayjs(reqDate).format("DD-MM-YYYY") : "..."}
        </Text>
      ),
    },

    {
      id: 6,
      key: "status",
      name: t("INVENTORY_REQUISITION.REQUISITION_LIST.HR.TABLE.COLUMN.STATUS"),
      render: (status: string) => {
        return status.toUpperCase() === "DRAFT" &&
          roles.includes(PERMISSIONS.INVENTORY_APPROVE_REQUISITION_S) ? (
          <StatusBadge status={STATUS.ACTION_NEEDED} />
        ) : status.toUpperCase() === "APPROVED" &&
          roles.includes(PERMISSIONS.INVENTORY_ASSIGN_REQUISITION_S) ? (
          <StatusBadge status={STATUS.ACTION_NEEDED} />
        ) : (
          <StatusBadge status={status} />
        );
      },
    },
    {
      id: 7,
      key: "id",
      name: "",
      render: (id: number) => {
        return <ViewButton link={`${id}`} />;
      },
    },
  ];
};
